module.exports = __webpack_public_path__ + "img/phone.37fa097.webp";